import React from 'react';
import './Contact.css';
import hero from '../images/portfolio-hero.jpg';
import Header from "../Header/Header"
import HeroSection from '../Components/HeroSection/HeroSection';
import { Container, Row, Col , Form, Alert} from 'bootstrap-4-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Recaptcha from "react-recaptcha";
import Footer from '../Footer/Footer';
import axios from "axios";
import ReactGA from 'react-ga';

class Contact extends React.Component{

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
         this.state = {
             email: '',
             name: '',
             message: ''
         }
         this.handleTextChange = this.handleTextChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
    state= {
        posted: '',
        loading: false,
    }
    componentDidMount() {
        ReactGA.pageview('/contact/');
    }
     handleNameChange = event => {
         this.setState({
             name: event.target.value
         })
     }
     handleEmailChange = event => {
         this.setState({
             email: event.target.value
         })
     }
     handleTextChange = event => {
         this.setState({
             text: event.target.value
         })
     }
    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            loading: true,
            
        })
        
       axios.post('moobifunapi/v1/contactus?Name=' + this.state.name + '&email=' + this.state.email + '&Message=' + this.state.text + ''
                , {
                   headers: {
                         'Content-Type': 'application / x - www - form - urlencoded',
                         'Content-lenghth': 41
                   }
               }
       )
        .then(response => {
            this.setState({
                loading: false,
                posted: <Alert success>
                    <i className="fa fa-check"></i>
                    <span>Thank you for contacting us, will get back to you soon!</span>
                </Alert>,
                name: '',
                email: '',
                text: ''
            });
        })
        .catch(fresponse => {
            this.setState({
                loading: false,
                posted: <Alert danger>
                <i className="fa fa-exclamation-triangle"></i>
                <span>An error happened while proccessing your request. Please try again!</span>
            </Alert>
            });
        
        });
    }

    render() {
        let loader = 
        <div className="form-loader">
            <i className="fa fa-spinner fa-spin"></i>
        </div>;
       return (
        <div className="contact-page">
            <Header />
            <HeroSection background={hero} pageTitle="Contact Us" />
            <section className="page-content">
            
                <div className="contactus-canvas">
                    <Container>
                        <ul className="breadcrumbs">
                            <li><Link to="/">Homepage</Link></li>
                            <li><Link to="/contact/" className="current">Contact Us</Link></li>
                        </ul>
                        <div className="contact-details">
                            <div className="center-align">
                                <h2>You can find us here</h2>
                            </div>
                            <address>
                                <span className="country">France</span>
								<span className="address">69100 Villeurbanne</span>
                                <span className="address">Lyon Business Center<br/>1 Esplanade Miriam Makeba</span>
                                <span className="address">+33 (0) 4 80 80 69 80</span>
                            </address>
                        </div>
                    </Container>
                </div>
                <div className="contact-form">
                    <Container>
                        <Row className="row-center">
                            <Col col="md-8 12">
                                <h2>We are here! How can we help you?</h2>
                                <Form onSubmit={this.handleSubmit} >
                                <Form.Group>
                                        <label htmlFor="name">Full Name</label>
                                        <Form.Input type="text" id="name" required autocomplete="off" value={this.state.name}   onChange={this.handleNameChange} />
                                    </Form.Group>
                                    <Form.Group>
                                        <label htmlFor="email">Email address</label>
                                        <Form.Input type="email" required id="email" autocomplete="off" value={this.state.email}  onChange={this.handleEmailChange} />
                                    </Form.Group>
                                    <Form.Group>
                                        <label htmlFor="message">Message</label>
                                        <Form.Textarea id="message" rows="3" required autocomplete="off" value={this.state.text}  onChange={this.handleTextChange}></Form.Textarea>
                                    </Form.Group>
                                    <Recaptcha className="text-center"
                                        sitekey="6LcfzIsUAAAAAP8WTOuUu4fpX-1gtavLSYVNb6TG"
                                        render="explicit"
                                    />
                                     {this.state.loading ? loader : ""}
                                    <button className="main-btn" primary type="submit">Send</button>
                                </Form>
                                {this.state.posted}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            <Footer />
        </div>
       );
    }
}
export default Contact;
